import React from 'react'
import { Route, Switch, useParams } from 'react-router-dom'
import { url2section } from 'ion-sections'
import loadable from '@loadable/component'
import { DefaultSectionPageSkeletonWrapper, ArticlePageSkeleton } from '../components/Skeletons'

const DefaultSectionPage = loadable(() => import('../pages/DefaultSectionPage'), {
  fallback: <DefaultSectionPageSkeletonWrapper />
})
const TagPage  = loadable(() => import('../pages/TagPage'))
const Article = loadable(() => import('../pages/Article'), {
  fallback: <ArticlePageSkeleton />
})

const RenderArticle = (props) => {
  const { contentKey } = useParams()
  return <Article {...props} contentKey={contentKey} />
}

const Technology = (props) => (
  <Switch>
    <Route path='/technology' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology'
        relatedSections={[{ id: 'business'}, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/techsperts' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='IOL Tech | Latest Tech and Gaming News from Around the World'
        description='We bring you the latest news all about technology, gaming, events, nanotechnology, new technology, 3D printing, internet security, mobile and digital developments.'
      />
    )} />
    <Route path='/technology/mobile-apps' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/mobile-apps'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/techsperts' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Latest Mobile and Phone News and Reviews | IOL Tech'
        description='Stay up-to-date with the latest mobile news, launches, product and gadget reviews on some of the most sort after smartphones, apps and popular network providers.'
      />
    )} />
    <Route path='/technology/gadgets' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/gadgets'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/techsperts' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Latest and Trending Gadget News and Reviews | IOL Tech'
        description='IOL Tech covers all that you need to know on smartphones, fitness watches, laptops and audio devices. Get news on the latest launches, features and reviews.'
      />
    )} />
    <Route path='/technology/fintech' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/fintech'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/gaming' }, { id: 'technology/techsperts' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Latest and Developing FinTech News and Topics | IOL Tech'
        description='We make it easy for you to stay up-to-date with the latest FinTech news, insight and analysis on Blockchain, cryptocurrency, startups and artificial intelligence.'
      />
    )} />
    <Route path='/technology/software-and-internet' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/software-and-internet'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/techsperts' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Latest and Developing Software and Internet News | IOL Tech'
        description='We give you hardware, software and computing information on networks, operating systems, firewalls, clouds and backup systems, search engine and open-source releases.'
      />
    )} />
    <Route path='/technology/gaming' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/gaming'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/techsperts' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Latest and Trending Gaming News and Reviews | IOL Tech'
        description='We keep you up-to-date with most exciting news on the latest video games be it PC or console with reviews on latest releases for every gamer`s pleasure.'
      />
    )} />
    <Route path='/technology/techsperts' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/techsperts'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Insights and Opinion on Technology | Techsperts | IOL Tech'
        description='IOL Tech gives you a better understanding of what is going on in the Tech world with analysis and commentary from the sharpest minds in Technology.'
      />
    )} />
    <Route path='/technology/big-tech' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/big-tech'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/esports' }, { id: 'technology/shopping' }]}
        title='Big Tech | IOL Tech'
        description=''
      />
    )} />
    <Route path='/technology/esports' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/esports'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/big-tech' }, { id: 'technology/shopping' }]}
        title='Esports | IOL Tech'
        description=''
      />
    )} />
    <Route path='/technology/shopping' exact render={() => (
      <DefaultSectionPage {...props}
        section='technology/shopping'
        relatedSections={[{ id: 'business'}, { id: 'technology' }, { id: 'technology/mobile-apps' }, { id: 'technology/gadgets' }, { id: 'technology/fintech' }, { id: 'technology/gaming' }, { id: 'technology/big-tech' }, { id: 'technology/esports' }]}
        title='Shopping | IOL Tech'
        description=''
      />
    )} />
    <Route path={'/technology/mobile-apps/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} oovvuu='4605e0ae-4ee1-4abb-9ca6-22763e4f6f14' />
    )} />
    <Route path={'/technology/gadgets/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} oovvuu='edfc1c18-f49b-487b-b7a4-dc0391be2660' />
    )} />
    <Route path={'/technology/fintech/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} oovvuu='819f53cc-1721-4978-8085-ec2a4279de59' />
    )} />
    <Route path={'/technology/gaming/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} oovvuu='3ed7884a-d4d8-4c57-83b7-b8f3b0bffbd9' />
    )} />
    <Route path={'/technology/software-and-internet/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} oovvuu='3624797f-6cdc-4418-8dec-0f947f226543' />
    )} />
    <Route path={'/technology/techsperts/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} oovvuu='edfc1c18-f49b-487b-b7a4-dc0391be2660' />
    )} />
    <Route path={'/technology/big-tech/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/esports/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/shopping/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/:section([a-zA-Z0-9-/]+)/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/:section([a-zA-Z0-9-/]+)/:title*([-])*:contentKey([0-9]{5,})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/:title*([-])*:contentKey([0-9]{5,})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/technology/:section([a-zA-Z0-9-/]+)'} exact render={() => (
      <TagPage {...props}
        section={url2section(props.location.pathname)}
        url={props.location.pathname}
      />
    )} />
  </Switch>
)

export default Technology
